export const WIZARDTYPES = {
    authenticate: 'authenticate',
    mapproducts: 'mapproducts',
    maptickets: 'maptickets',
    syncsettings: 'syncsettings',
}
